import { render, staticRenderFns } from "./tags-grid.vue?vue&type=template&id=6dcb7074&"
import script from "./tags-grid.vue?vue&type=script&lang=ts&"
export * from "./tags-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports